import type { RowData } from "@tanstack/react-table";
import { flexRender } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import type { JSX } from "react";
import { memo, useMemo } from "react";

import styles from "../styles.module.scss";

import type { ITableHeadProps } from "@components/organisms/table/types";
import { Typography } from "@/components/atoms/typography";

export const Thead = memo(function Thead<TData extends RowData>({
  headerGroups,
  showRow,
}: ITableHeadProps<TData>) {
  const { t } = useTranslation("common");

  const tableHeaderComponents = useMemo(
    () =>
      headerGroups?.map((headerEl, index) => {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <tr key={`${headerEl.id}index${index}`}>
            {showRow && <th>{t("row")}</th>}
            {headerEl.headers.map((columnEl, index2) => {
              return (
                <th
                  key={
                    /* eslint-disable-next-line react/no-array-index-key */
                    `${columnEl.id}index2${index2}`
                  }
                  colSpan={columnEl.colSpan}
                  className={styles.th}
                  style={
                    columnEl.getSize() === 150
                      ? undefined
                      : { width: columnEl.getSize() }
                  }
                >
                  <Typography color={"inherit"}>
                    {flexRender(
                      columnEl.column.columnDef.header,
                      columnEl.getContext(),
                    )}
                  </Typography>
                </th>
              );
            })}
          </tr>
        );
      }),
    [headerGroups, showRow, t],
  );

  return <thead className={styles.thead}>{tableHeaderComponents}</thead>;
}) as <TData extends RowData>(props: ITableHeadProps<TData>) => JSX.Element;
